import "./App.css";
// import Carousel from "./components/Carousel";
// import images from "./components/images";
import Home from "./pages/home";

const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default App;
